/**
 * Brand artwork resolved from the build environment.
 *
 * Values arrive through Vite's `envPrefix` (see `vite.config.ts`) so the same
 * build can be re-pointed at different logos without a code change. See
 * `apps/web/.env.example`.
 */
export const APP_LOGO_URL = (import.meta.env.APP_LOGO as string | undefined)?.trim() ?? ''

/** Secondary partner logo (Bagong Pilipinas) shown beside the brand logo. */
export const SECONDARY_LOGO_URL = (import.meta.env.SECONDARY_LOGO as string | undefined)?.trim() ?? ''
